module.exports = __webpack_public_path__ + "static/media/18.90c72b04.svg";